(function () {
  'use strict';
  var d = document, html = d.documentElement;

  var cd = d.querySelector('[data-jfn-countdown]');
  if (cd) {
    var tz = cd.getAttribute('data-tz') || 'Europe/Berlin', nodes = {};
    [].forEach.call(cd.querySelectorAll('[data-d]'), function (n) { nodes[n.getAttribute('data-d')] = n; });
    var elapsed = function () {
      try {
        var p = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date()), g = function (t) { for (var i = 0; i < p.length; i++) { if (p[i].type === t) { return parseInt(p[i].value, 10); } } return 0; };
        var h = g('hour'); if (h === 24) { h = 0; }
        return h * 3600 + g('minute') * 60 + g('second');
      } catch (e) { var n = new Date(); return n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds(); }
    };
    var pad = function (n) { n = String(n); return n.length < 2 ? '0' + n : n; };
    var set = function (k, v) { if (nodes[k] && nodes[k].textContent !== v) { nodes[k].textContent = v; } };
    var tick = function () {
      var left = 86400 - elapsed(); if (left > 86399) { left = 86399; } if (left < 0) { left = 0; }
      var h = pad(Math.floor(left / 3600)), m = pad(Math.floor((left % 3600) / 60)), s = pad(left % 60);
      set('d0', '0'); set('d1', '0'); set('h0', h.charAt(0)); set('h1', h.charAt(1)); set('m0', m.charAt(0)); set('m1', m.charAt(1)); set('s0', s.charAt(0)); set('s1', s.charAt(1));
    };
    tick(); setInterval(tick, 1000);
  }

  var fcols = d.querySelectorAll('[data-jfn-fcol]');
  if (fcols.length && window.matchMedia) {
    var mq = window.matchMedia('(max-width: 768px)');
    var apply = function () { [].forEach.call(fcols, function (c) { c.open = !mq.matches; }); };
    apply();
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    [].forEach.call(fcols, function (c) { c.firstElementChild.addEventListener('click', function (e) { if (!mq.matches) { e.preventDefault(); } }); });
  }

  (function () {
    var els = d.querySelectorAll('[data-jfn-cart-count],[data-jfh-cart-count]');
    if (!els.length || !window.fetch) { return; }
    var re = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
    var busy = false;
    function paint(n) { [].forEach.call(els, function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
    function refresh() {
      if (busy) { return; } busy = true;
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { paint(c.item_count); })
        .catch(function () {}).then(function () { busy = false; });
    }
    var of = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (re.test(u)) { p.then(function () { setTimeout(refresh, 150); }, function () {}); }
      return p;
    };
    var ox = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      if (re.test(String(u))) { this.addEventListener('load', function () { setTimeout(refresh, 150); }); }
      return ox.apply(this, arguments);
    };
    ['cart:updated', 'cart:change', 'cart:refresh', 'ajaxProduct:added', 'cart:build'].forEach(function (ev) { d.addEventListener(ev, refresh); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh(); } });
  })();

  (function () {
    var els = d.querySelectorAll('[data-jfn-rev]');
    if (!els.length || !window.fetch) { return; }
    var run = function () {
      fetch('https://api.reviews.io/merchant/reviews?store=www.thefrankjuice.com').then(function (r) { return r.json(); }).then(function (j) {
        var n = j && j.stats && parseInt(j.stats.total_reviews, 10), a = j && j.stats && parseFloat(j.stats.average_rating);
        if (!n || !a) { return; }
        var ns = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'), as = a.toFixed(1).replace('.', ',');
        [].forEach.call(els, function (el) { el.textContent = el.getAttribute('data-jfn-rev') === 'n' ? ns : as; });
      }).catch(function () {});
    };
    if ('requestIdleCallback' in window) { requestIdleCallback(run, { timeout: 4000 }); } else { setTimeout(run, 2500); }
  })();

  (function () {
    var f = d.querySelector('[data-jfn-footer]');
    if (!f) { return; }
    var on = function () { f.classList.add('is-bg'); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { on(); io.disconnect(); } }, { rootMargin: '800px 0px' });
      io.observe(f);
    } else { on(); }
  })();

  (function () {
    var els = d.querySelectorAll('[data-jfn-people-n]');
    if (!els.length) { return; }
    var tick = function () { var n = Math.floor(Math.random() * (170 - 100 + 1)) + 100; [].forEach.call(els, function (e) { e.textContent = n; }); };
    tick(); setInterval(tick, 10000);
  })();
})();
